import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  getAssetManagerCategoriesStart,
  getAssetManagerCategoriesSuccess,
  getAssetManagerCategoriesFailed,
  getAssetManagerCategoryTagsStart,
  getAssetManagerCategoryTagsSuccess,
  getAssetManagerCategoryTagsFailed,
  getAssetManagerImagesStart,
  getAssetManagerImagesSuccess,
  getAssetManagerImagesFailed,
  uploadProviderImageStart,
  uploadProviderImageSuccess,
  uploadProviderImageFailed,
  uploadPrivateImageStart,
  uploadPrivateImageSuccess,
  uploadPrivateImageFailed,
  getAssetManagerTagByCodeStart,
  getAssetManagerTagByCodeSuccess,
  getAssetManagerTagByCodeFailed
} from 'redux/actions/asset_manager';
import { serialize } from '../helpers/api';


export const getAssetManagerCategoriesApi = async ({dispatch}) => {
  try {
    dispatch(getAssetManagerCategoriesStart());
    const {data} = await api.get(`${shopManagerApi}/assets/categories`);
    dispatch(getAssetManagerCategoriesSuccess(data));
  } catch (e) {
    dispatch(getAssetManagerCategoriesFailed(e));
  }
};

export const getAssetManagerCategoryTagsApi = async ({dispatch, categoryName = ''}) => {
  try {
    const params = {};
    categoryName && (params.categoryName = categoryName);

    dispatch(getAssetManagerCategoryTagsStart());
    const allCategories = await api.get(`${shopManagerApi}/assets/categories`);
    const currentCategoryData = allCategories.data.items.find((category) => category.name === categoryName);
    const {data} = await api.get(`${shopManagerApi}/assets/tags${serialize(params)}`);
    dispatch(getAssetManagerCategoryTagsSuccess(data, currentCategoryData));
  } catch (e) {
    dispatch(getAssetManagerCategoryTagsFailed(e));
  }
};

export const getAssetManagerTagByCodeApi = async ({ dispatch, tagCode }) => {
  try {
    dispatch(getAssetManagerTagByCodeStart());
    const { data } = await api.get(`${shopManagerApi}/assets/tags/${encodeURIComponent(tagCode)}`);
    dispatch(getAssetManagerTagByCodeSuccess(data));
    return data;
  } catch (e) {
    dispatch(getAssetManagerTagByCodeFailed(e));
    return null;
  }
};

export const getAssetManagerImagesApi = async ({
  dispatch,
  limit,
  page = 1,
  tagIds = '',
  categoryIds = '',
  isPrivate
}) => {
  try {
    const params = {page};
    tagIds && (params.tagIds = tagIds);
    categoryIds && (params.categoryIds = categoryIds);
    limit && (params.limit = limit);
    isPrivate !== undefined && (params.isPrivate = isPrivate);

    dispatch(getAssetManagerImagesStart());
    const {data} = await api.get(`${shopManagerApi}/assets/images${serialize(params)}`);
    dispatch(getAssetManagerImagesSuccess(data, tagIds, isPrivate));
  } catch (e) {
    dispatch(getAssetManagerImagesFailed(e));
  }
};

export const uploadProviderImageApi = async ({dispatch, formData, isAddingNewTag = false}) => {
  try {
    dispatch(uploadProviderImageStart());
    const {data} = await api.post(`${shopManagerApi}/assets/images`, formData, {headers: { 'Content-Type': 'multipart/form-data' }});
    dispatch(uploadProviderImageSuccess(data));

    if (isAddingNewTag) {
      getAssetManagerCategoryTagsApi({dispatch, categoryName: 'Storebuild-automaton'});
    }
  } catch (e) {
    dispatch(uploadProviderImageFailed(e));
  }
};

export const uploadPrivateImageApi = async ({dispatch, formData, isAddingNewTag = false, categoryName = 'Storebuild-automaton'}) => {
  try {
    dispatch(uploadPrivateImageStart());
    const {data} = await api.post(`${shopManagerApi}/assets/images`, formData, {headers: { 'Content-Type': 'multipart/form-data' }});
    dispatch(uploadPrivateImageSuccess(data));

    if (isAddingNewTag && categoryName) {
      getAssetManagerCategoryTagsApi({dispatch, categoryName});
    }

    return data.result;
  } catch (e) {
    dispatch(uploadPrivateImageFailed(e));
    return null;
  }
};
